import { render, staticRenderFns } from "./students-messages.vue?vue&type=template&id=a902d1b0&"
import script from "./students-messages.vue?vue&type=script&lang=js&"
export * from "./students-messages.vue?vue&type=script&lang=js&"
import style0 from "./students-messages.vue?vue&type=style&index=0&id=a902d1b0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports